import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import * as FaIcons from "react-icons/fa";

const R18CompletionScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get site ID from URL query parameters
  const query = queryString.parse(location.search);
  const siteId = query.site;

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  return (
    <>
      <div className="sub-form">
        <h2 className="title">
          Thank you! Your registration has been successfully completed.
          <br /> One of our team members will reach out to you within one
          business day.
        </h2>
      </div>
      <div className="complete-buttons-container">
        {siteId && (
          <button className="btninfo" onClick={() => navigate(-1)}>
            <FaIcons.FaInfoCircle />
            Go to Information Page
          </button>
        )}
        <button className="Homeinfo" onClick={() => navigate("/")}>
          <FaIcons.FaHome />
          Go to Home Page
        </button>
      </div>
    </>
  );
};

export default R18CompletionScreen;
